export enum EventEnum {
    PlayerInit = 'initialization',
    Loading = 'loading',
    Loaded = 'loaded',
    Playing = 'playing',
    FormSubmited = 'form-submitted',
    ButtonClicked = 'button-clicked',
    CheckboxChanged = 'checkbox-changed',
    DropdownOptionSelected = 'dropdown-option-selected',
    InputFocused = 'input-focused',
    VideoError = 'video-error',
    ResolutionChanged = 'resolution-changed',
    Bandwidth = 'bandwidth',
    FirstPlay = 'first-play',
    VideoPlayed = 'video-played',
    VideoCompleted = 'video-completed'
}
